<template>
  <div id="app">
    <v-app id="inspire" lang="it" class="notranslate" content="notranslate">
      <v-main style="background-color: #fff !important" :style="{
        'max-width': style.maxWidth,
        'max-height': style.maxHeight,
        'margin-left': style.marginLeft,
        'margin-right': style.marginRight,
      }">
        <!--Toolbar -->
        <Tool-Bar @esci="esci" :utente="utente" :nomeSel="nomeSel"
          v-if="$store.getters['auth/isAuthenticated']"></Tool-Bar>

        <!-- header -->
        <Header :loading="loading" @goToHome="goToHome"></Header>
        <ToolbarPreventivi :loading="loading" v-if="seeToolbarPreve()"></ToolbarPreventivi>
        <!-- Router view -->
        <router-view @setStyle="setStyle" />
      </v-main>

      <!-- Footer -->
      <Footer :fixed="style.footerFixed" style="position: absolute; width: 100%; bottom: 0; background-color: #fff"></Footer>

      <!-- Plugins -->
      <toast></toast>
      <wait></wait>
      <!-- Dialog confirm -->
      <confirm ref="confirm"></confirm>
    </v-app>
  </div>
</template>

<script>
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import ToolBar from "@/components/layout/ToolBar";

import ToolbarPreventivi from "@/views/preventivi/ToolbarPreventivi";

import Confirm from "@/components/ui/Confirm";

import { mapState } from "vuex";

export default {
  name: "app",

  components: {
    Header,
    Footer,
    Confirm,
    ToolBar,
    ToolbarPreventivi,
  },

  data: () => ({
    items: [],
    style: {
      maxWidth: "",
      maxHeight: "",
      marginLeft: "",
      marginRight: "",
      footerFixed: true,
    },
  }),

  methods: {
    setStyle(style) {
      this.style = style;
    },

    goToHome() {
      if (this.$store.getters["auth/isAuthenticated"] == false) return;

      this.$root.$router.push("/");
    },

    async esci() {
      await this.$store.dispatch("auth/logout");
    },

    seeToolbarPreve() {
      return (
        window.location.pathname == "/preventivo" ||
        window.location.pathname == "/preventivi"
      );
    },
  },

  computed: {
    ...mapState({
      loading: (state) => state.app.loading,
      utente: (state) => state.user.user,
      role: (state) => state.user.role,
      menu: (state) => state.user.menu,
      nomeSel: (state) => state.user.userSwitch,
    }),
  },

  mounted() {
    this.$root.$confirm = this.$refs.confirm.open;
  },
};
</script>


<style>
.application.theme--light {
  background: #f5f5f5 !important;
}

/* ----- Tabelle ----- */
.v-datatable__actions__select {
  visibility: hidden;
}

table.table thead th {
  white-space: normal !important;
  padding: 0px !important;
}

.application .theme--light.table thead tr:first-child,
.theme--light .table thead tr:first-child {
  border-bottom: 0px;
}

.table__overflow {
  border-radius: 5px;
}

.application .theme--light.table thead th,
.theme--light .table thead th {
  color: white;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: bold;
}

/* ----------------- */

/* ----------- @media queris ------------ */
/* @media only screen and (max-width: 780px) {
  .containerMain {
    padding: 0px !important;
  }

  .visTab {
    display: none;
  }

  .tableWidth {
    width: 100vw;
  }
} */
/* ----------------- */

/* --------- Tooltip --------- */
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
  font-size: 14px;
  font-family: Arial, Helvetica, sans-serif;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}

/* ------------------------ */
</style>
